import type { StatusOption } from "../types/global.types";
import { cn } from "../utils/global.utils";
import { capitalize } from "../utils/string.types";

interface StatusTagProps {
  value: string;
  config?: StatusOption[];
  className?: string;
}

const StatusTag = ({ value, config, className }: StatusTagProps) => {
  const matched = config?.find(
    (s) => String(s.value).toLowerCase() === String(value).toLowerCase()
  );

  if (!matched && !className) return <span>-</span>;

  return (
    <span className={cn("status", matched?.className || className)}>
      {matched ? capitalize(matched.label) : capitalize(value)}
    </span>
  );
};

export default StatusTag;
